import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import photosActions from 'store/resources/sharedPhotosV2/actions'
import videosActions from 'store/resources/sharedVideosV2/actions'
import filesActions from 'store/resources/sharedFilesV2/actions'
import linksActions from 'store/resources/sharedLinksV2/actions'
import { fileTypesEnum } from 'components/modals/v2/chat_shared_modal/file_types_enum'
import AuthHelper from 'helpers/auth_helper'

const useGetSharedFilesCount = conversationId => {
  const dispatch = useDispatch()

  const handleFetchCount = useCallback(async activeTab => {
    if (!AuthHelper.logged_in) return false

    if (activeTab !== fileTypesEnum.photos) dispatch(photosActions.resourceFetchRequest(
      `/v2/conversations/${conversationId}/messages?per_page=1&page=1&message_type=image`))
    if (activeTab !== fileTypesEnum.videos) dispatch(videosActions.resourceFetchRequest(
      `/v2/conversations/${conversationId}/messages?per_page=1&page=1&message_type=video`))
    if (activeTab !== fileTypesEnum.files) dispatch(filesActions.resourceFetchRequest(
      `/v2/conversations/${conversationId}/messages?per_page=1&page=1&message_type=file`))
    if (activeTab !== fileTypesEnum.links) dispatch(linksActions.resourceFetchRequest(
      `/v2/conversations/${conversationId}/messages?per_page=1&page=1&message_type=link`))
  }, [conversationId])

  return handleFetchCount
}

export default useGetSharedFilesCount
